"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDefaultOption = exports.getHighlightTextList = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const helpers_1 = require("../../Grid/cellRenderers/helpers");
const helpers_2 = require("../../helpers");
const Icon_1 = require("../../Icon");
const StackView_1 = require("../../StackView");
const Text_1 = require("../../Text");
const Tooltip_1 = require("../../Tooltip");
const View_1 = require("../../View");
const helpers_3 = require("../helpers");
const HighlightText = styled_components_1.default.span `
    font-weight: ${({ theme }) => theme === null || theme === void 0 ? void 0 : theme.fonts.weights.bold};
`;
// TODO: test for 'javascript';
// TODO: test for regexp special symbol
// TODO: test for end "\"
const getHighlightTextList = (text, pattern) => {
    const result = text.split(new RegExp(`(${(0, helpers_3.escapeRegExpString)(pattern)})`, 'gi'));
    if (result.length > 2) {
        return [result[0], result[1], result.slice(2).join('')];
    }
    return [text];
};
exports.getHighlightTextList = getHighlightTextList;
const renderHighlightText = ({ before, highlight, after }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        before,
        react_1.default.createElement(HighlightText, null, highlight),
        after));
};
const TextContent = ({ disabled, formattedText, matchPattern }) => {
    let textContent = (react_1.default.createElement(Text_1.Text, { view: disabled ? Text_1.TEXT_VIEW.secondary : Text_1.TEXT_VIEW.primary, truncate: true }, formattedText));
    if (!disabled && formattedText && matchPattern) {
        const [before, highlight, after] = (0, exports.getHighlightTextList)(formattedText, matchPattern);
        if (highlight) {
            textContent = (react_1.default.createElement(Text_1.Text, { view: Text_1.TEXT_VIEW.primary, truncate: true }, renderHighlightText({ before, highlight, after: after || '' })));
        }
    }
    return textContent;
};
const TextContentWithTooltip = ({ disabled, text, matchPattern }) => {
    const ref = (0, react_1.useRef)(null);
    return (0, Tooltip_1.useTooltip)({
        maxWidth: helpers_3.DEFAULT_MAX_WIDTH_TOOLTIP,
        renderContent: () => react_1.default.createElement(helpers_1.TooltipText, { size: Text_1.TEXT_SIZE.s }, text),
        render: (tooltipProps) => {
            return (react_1.default.createElement(View_1.View, Object.assign({}, tooltipProps, { ref: ref, align: View_1.VIEW_ALIGN.center, size: { height: helpers_2.SIZE_XL }, onMouseEnter: (0, helpers_1.onMouseEnterHandlerDecorator)(tooltipProps.onMouseEnter, ref), onMouseLeave: tooltipProps.onMouseLeave }),
                react_1.default.createElement(TextContent, { disabled: disabled, formattedText: text, matchPattern: matchPattern })));
        }
    });
};
function createDefaultOption({ className, iconGetter, renderRightAddon, formatText = ({ text }) => text } = {}) {
    return function defaultOptionRenderer({ option, disabled, text, matchPattern }) {
        const icon = iconGetter === null || iconGetter === void 0 ? void 0 : iconGetter({ option });
        const formattedText = formatText({ text, option });
        return (react_1.default.createElement(StackView_1.StackView, { className: className, testId: 'option', direction: StackView_1.STACK_DIRECTION.row, gap: StackView_1.STACK_GAP.s, align: StackView_1.STACK_ALIGN.center, distribution: StackView_1.STACK_DISTRIBUTION.lastFill },
            icon && react_1.default.createElement(Icon_1.Icon, { src: icon, disabled: disabled }),
            react_1.default.createElement(StackView_1.StackView, { direction: StackView_1.STACK_DIRECTION.row, align: StackView_1.STACK_ALIGN.center, distribution: StackView_1.STACK_DISTRIBUTION.start, gap: StackView_1.STACK_GAP.m },
                react_1.default.createElement(TextContentWithTooltip, { disabled: disabled, text: formattedText, matchPattern: matchPattern }),
                renderRightAddon && (react_1.default.createElement(View_1.View, { align: View_1.VIEW_ALIGN.center, collapsable: false }, renderRightAddon === null || renderRightAddon === void 0 ? void 0 : renderRightAddon())))));
    };
}
exports.createDefaultOption = createDefaultOption;
//# sourceMappingURL=defaultOptionRenderer.js.map